import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { TMarkProfileCompleteApiResponse } from '../types/SaveWorkerType.api';

export const markProfileComplete = async (): Promise<TMarkProfileCompleteApiResponse> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.patch<TMarkProfileCompleteApiResponse>(
    '/users',
    { is_profile_complete: true },
    { headers },
  );
  return data;
};
